/**
 * @generated SignedSource<<be445bfe1ebb0623f6e306d5045d9397>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpsertGCPIntegrationInput = {
  accessConfig?: GCPIntegrationAccessConfigInput | null | undefined;
  accessConfigBlob?: string | null | undefined;
  customerConfig?: GCPIntegrationCustomerConfigInput | null | undefined;
  key: string;
};
export type GCPIntegrationCustomerConfigInput = {
  costSources?: ReadonlyArray<GCPIntegrationCustomerCostSourceInput> | null | undefined;
  infrastructure?: GCPIntegrationCustomerInfrastructureInput | null | undefined;
  organizations?: ReadonlyArray<GCPIntegrationCustomerOrganizationInput> | null | undefined;
  securityContexts?: ReadonlyArray<GCPIntegrationCustomerSecurityContextInput> | null | undefined;
};
export type GCPIntegrationCustomerInfrastructureInput = {
  createProject?: GCPIntegrationCustomerCreateProjectInput | null | undefined;
  projectId?: string | null | undefined;
  resourceLocation?: string | null | undefined;
  resourcePrefix?: string | null | undefined;
};
export type GCPIntegrationCustomerCreateProjectInput = {
  billingAccountId?: string | null | undefined;
  folderId?: string | null | undefined;
  labels?: ReadonlyArray<TagInput> | null | undefined;
  orgId?: string | null | undefined;
};
export type TagInput = {
  key: string;
  value?: string | null | undefined;
};
export type GCPIntegrationCustomerOrganizationInput = {
  folderIds: ReadonlyArray<string>;
  orgId: string;
  projectIds: ReadonlyArray<string>;
};
export type GCPIntegrationCustomerCostSourceInput = {
  billingTable: string;
};
export type GCPIntegrationCustomerSecurityContextInput = {
  extraRoles: ReadonlyArray<string>;
  name: string;
};
export type GCPIntegrationAccessConfigInput = {
  costSources: ReadonlyArray<GCPIntegrationAccessCostSourceInput>;
  infrastructure: GCPIntegrationAccessInfrastructureInput;
  organizations: ReadonlyArray<GCPIntegrationAccessOrganizationInput>;
  roundtripDigest: string;
  securityContexts: ReadonlyArray<GCPIntegrationAccessSecurityContextInput>;
};
export type GCPIntegrationAccessInfrastructureInput = {
  baselineRoles: ReadonlyArray<string>;
  projectId: string;
  relay: GCPIntegrationAccessRelayInput;
  wif: GCPIntegrationAccessWIFInput;
};
export type GCPIntegrationAccessRelayInput = {
  oauthId: string;
};
export type GCPIntegrationAccessWIFInput = {
  audience: string;
  principals: GCPIntegrationAccessWIFPrincipalsInput;
};
export type GCPIntegrationAccessWIFPrincipalsInput = {
  costQuery: string;
  readOnly: string;
};
export type GCPIntegrationAccessOrganizationInput = {
  folders: ReadonlyArray<GCPIntegrationAccessOrganizationFolderInput>;
  id: string;
  name: string;
  projects: ReadonlyArray<GCPIntegrationAccessOrganizationProjectInput>;
};
export type GCPIntegrationAccessOrganizationFolderInput = {
  id: string;
  name: string;
};
export type GCPIntegrationAccessOrganizationProjectInput = {
  id: string;
  number: string;
};
export type GCPIntegrationAccessCostSourceInput = {
  billingTable: string;
  location: string;
};
export type GCPIntegrationAccessSecurityContextInput = {
  extraRoles: ReadonlyArray<string>;
  name: string;
  principal: string;
};
export type UpsertGCPIntegrationMutation$variables = {
  connections: ReadonlyArray<string>;
  input: UpsertGCPIntegrationInput;
};
export type UpsertGCPIntegrationMutation$data = {
  readonly upsertGCPIntegration: {
    readonly gcpIntegration: {
      readonly accessConfig: {
        readonly costSources: ReadonlyArray<{
          readonly billingTable: string;
        }>;
        readonly infrastructure: {
          readonly projectId: string;
        };
        readonly organizations: ReadonlyArray<{
          readonly folders: ReadonlyArray<{
            readonly id: string;
          }>;
          readonly id: string;
          readonly name: string;
          readonly projects: ReadonlyArray<{
            readonly id: string;
          }>;
        }>;
        readonly roundtripDigest: string;
        readonly securityContexts: ReadonlyArray<{
          readonly extraRoles: ReadonlyArray<string>;
          readonly name: string;
        }>;
      } | null | undefined;
      readonly customerConfig: {
        readonly costSources: ReadonlyArray<{
          readonly billingTable: string;
        }>;
        readonly infrastructure: {
          readonly createProject: {
            readonly billingAccountId: string;
            readonly folderId: string | null | undefined;
            readonly labels: ReadonlyArray<{
              readonly key: string;
              readonly value: string | null | undefined;
            }>;
            readonly orgId: string | null | undefined;
          } | null | undefined;
          readonly projectId: string;
          readonly resourceLocation: string;
          readonly resourcePrefix: string;
        } | null | undefined;
        readonly organizations: ReadonlyArray<{
          readonly folderIds: ReadonlyArray<string>;
          readonly orgId: string;
          readonly projectIds: ReadonlyArray<string>;
        }>;
        readonly securityContexts: ReadonlyArray<{
          readonly extraRoles: ReadonlyArray<string>;
          readonly name: string;
        }>;
        readonly terraformModule: {
          readonly blockHCL: string;
          readonly roundtripDigest: string;
        } | null | undefined;
      };
      readonly key: string;
    } | null | undefined;
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
  };
};
export type UpsertGCPIntegrationMutation = {
  response: UpsertGCPIntegrationMutation$data;
  variables: UpsertGCPIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "billingTable",
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  (v5/*:: as any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roundtripDigest",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "extraRoles",
    "storageKey": null
  },
  (v7/*:: as any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "GCPIntegrationAccessConfig",
  "kind": "LinkedField",
  "name": "accessConfig",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GCPIntegrationAccessCostSource",
      "kind": "LinkedField",
      "name": "costSources",
      "plural": true,
      "selections": (v3/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GCPIntegrationAccessInfrastructure",
      "kind": "LinkedField",
      "name": "infrastructure",
      "plural": false,
      "selections": [
        (v4/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GCPIntegrationAccessOrganization",
      "kind": "LinkedField",
      "name": "organizations",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GCPIntegrationAccessOrganizationFolder",
          "kind": "LinkedField",
          "name": "folders",
          "plural": true,
          "selections": (v6/*:: as any*/),
          "storageKey": null
        },
        (v5/*:: as any*/),
        (v7/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "GCPIntegrationAccessOrganizationProject",
          "kind": "LinkedField",
          "name": "projects",
          "plural": true,
          "selections": (v6/*:: as any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v8/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "GCPIntegrationAccessSecurityContext",
      "kind": "LinkedField",
      "name": "securityContexts",
      "plural": true,
      "selections": (v9/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orgId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "GCPIntegrationCustomerConfig",
  "kind": "LinkedField",
  "name": "customerConfig",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GCPIntegrationCustomerCostSource",
      "kind": "LinkedField",
      "name": "costSources",
      "plural": true,
      "selections": (v3/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GCPIntegrationCustomerInfrastructure",
      "kind": "LinkedField",
      "name": "infrastructure",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GCPIntegrationCustomerCreateProject",
          "kind": "LinkedField",
          "name": "createProject",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "billingAccountId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "folderId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Tag",
              "kind": "LinkedField",
              "name": "labels",
              "plural": true,
              "selections": [
                (v11/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            (v12/*:: as any*/)
          ],
          "storageKey": null
        },
        (v4/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "resourceLocation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "resourcePrefix",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GCPIntegrationCustomerOrganization",
      "kind": "LinkedField",
      "name": "organizations",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "folderIds",
          "storageKey": null
        },
        (v12/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectIds",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GCPIntegrationCustomerSecurityContext",
      "kind": "LinkedField",
      "name": "securityContexts",
      "plural": true,
      "selections": (v9/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TerraformModule",
      "kind": "LinkedField",
      "name": "terraformModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "blockHCL",
          "storageKey": null
        },
        (v8/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpsertGCPIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "UpsertGCPIntegrationPayload",
        "kind": "LinkedField",
        "name": "upsertGCPIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GCPIntegration",
            "kind": "LinkedField",
            "name": "gcpIntegration",
            "plural": false,
            "selections": [
              (v10/*:: as any*/),
              (v13/*:: as any*/),
              (v11/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v14/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "UpsertGCPIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "UpsertGCPIntegrationPayload",
        "kind": "LinkedField",
        "name": "upsertGCPIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GCPIntegration",
            "kind": "LinkedField",
            "name": "gcpIntegration",
            "plural": false,
            "selections": [
              (v10/*:: as any*/),
              (v13/*:: as any*/),
              (v11/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "gcpIntegration",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "GCPIntegrationEdge"
              }
            ]
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isProblem"
              },
              (v14/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a899ae2f5781c6dca54b02332d7e4979",
    "id": null,
    "metadata": {},
    "name": "UpsertGCPIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation UpsertGCPIntegrationMutation(\n  $input: UpsertGCPIntegrationInput!\n) {\n  upsertGCPIntegration(input: $input) {\n    gcpIntegration {\n      accessConfig {\n        costSources {\n          billingTable\n        }\n        infrastructure {\n          projectId\n        }\n        organizations {\n          folders {\n            id\n          }\n          id\n          name\n          projects {\n            id\n          }\n        }\n        roundtripDigest\n        securityContexts {\n          extraRoles\n          name\n        }\n      }\n      customerConfig {\n        costSources {\n          billingTable\n        }\n        infrastructure {\n          createProject {\n            billingAccountId\n            folderId\n            labels {\n              key\n              value\n            }\n            orgId\n          }\n          projectId\n          resourceLocation\n          resourcePrefix\n        }\n        organizations {\n          folderIds\n          orgId\n          projectIds\n        }\n        securityContexts {\n          extraRoles\n          name\n        }\n        terraformModule {\n          blockHCL\n          roundtripDigest\n        }\n      }\n      key\n      id\n    }\n    problems {\n      __typename\n      __isProblem: __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0e9b8323d834dcd7d827ac82e2aca587";

export default node;
